export const FETCH_TREE_LOADING = 'FETCH_TREE_LOADING';
export const FETCH_TREE_SUCCESS = 'FETCH_TREE_SUCCESS';
export const FETCH_TREE_FAILED = 'FETCH_TREE_FAILED';
